<template>
    <div>Un momento por favor...</div>
</template>
<script>
  import Vue from 'vue'

  export default {
    data () {
      return {}
    },
    mounted () {
      Vue.ls.set('token', this.$route.params.access_token, this.$route.params.expires_in * 1000)
      window.close()
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/login/DirectLogin.vue